// extracted by mini-css-extract-plugin
export default {"primaryColor":"#642472","mainTextColorOnPrimary":"#fff","history":"History_history__16p5C","items":"History_items__yQIvX","headline":"History_headline__BOUix"};